import hooks from '../../../hooks'
import { useMutation } from 'react-query'
import React from 'react'

const useLocationMutation = ({
    id: locationId,
    name: defaultName,
    onSuccess = () => {}
}) => {
    const [ name, setName ] = React.useState(defaultName)
    const cacheKeys = hooks.useCacheKeys()
    const { clearCache } = hooks.useCache({ key: [cacheKeys.LOCATIONS], onReload: onSuccess })
    const { api, endpoints, url } = hooks.useApi()
    const { toastError, toastSuccess } = hooks.useToasts({ onSuccess: clearCache })

    const [ createLocation, { isLoading: isCreating }] = useMutation(
        () => api.post(endpoints.locations, { name }),
        {
            onSuccess: () => toastSuccess('Location created!'),
            onError: () => toastError('Error creating location.')
        }
    )

    const [ updateLocation, { isLoading: isUpdating }] = useMutation(
        () => api.put(url(endpoints.location, { locationId }), { name }),
        {
            onSuccess: () => toastSuccess('Location updated!'),
            onError: () => toastError('Error updating location.')
        }
    )

    const saveLocation = React.useCallback(() => {
        if (locationId) {
            updateLocation()
        } else {
            createLocation()
        }
    }, [locationId])

    const isSaving = isCreating || isUpdating

    return {
        name,
        setName,

        isSaving,
        saveLocation
    }
}

export default useLocationMutation